import React from 'react';
import { Modal } from 'antd';
import { Img } from 'components/Material';
import Icon from 'components/Icon';
import BaseComponent from 'components/BaseComponent';

/** 图片类型 放大图片 */
export class LargePictureComponent extends BaseComponent {

    render() {
        const { visible, src, hideLargePictureHandler } = this.props;
        if (!src) {
            return null;
        }
        return (
            <Modal title={null}
                visible={visible}
                width='auto'
                onCancel={null}
                footer={null}
                maskClosable={false}
                className='large-img-model'
            >
                <span className="large-model-close" onClick={(e) => { hideLargePictureHandler() }}><Icon className="close-o" /></span>
                <span className="large-span">
                    <Img src={src} alt="" className="large-img" />
                </span>
            </Modal>
        )
    }

}




// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/largePictureComponent.js